import { AiFillEye } from "react-icons/ai";
import { GoPerson } from "react-icons/go";
import RunningAdComp from "./RunningAd";
import { reactivateAdUrl } from "../../../api/endpoints";
import { useState } from "react";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";

const AdComponent = ({ runningAd, expiredAd, storeID, updateRunningAd, updateExpiredAd, setAlertDisplay }) => {
  const [isThereRunningAd, setIsThereRunningAd] = useState(false);

  const reactivatAd = async (adId) => {
    console.log("reactivate ad");
    if (runningAd && runningAd.status === "active") {
      console.log("there is already a running ad");
      setIsThereRunningAd(true);
    } else {
      try {
        let response = await fetch(reactivateAdUrl + storeID + "/" + adId, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        });
        if (response.ok) {
          let { ad, storeAds } = await response.json();
          updateRunningAd(ad);
          updateExpiredAd(storeAds.filter((ad) => ad.status === "expired"));
          setAlertDisplay({
            showAlert: true,
            title: "Ad reactivated successfully",
            message: "The corresponding amount has be deducted from your wallet",
            type: "success",
          });
        } else {
          uiAlert("something went wrong ad cant be reactivated", "error");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  /*  user.offlineCustomers.length +user.onlinecustomers.length */
  return (
    <>
      <div className='pAdcomponentDivWrapper'>
        <RunningAdComp runningAd={runningAd} />
        <div className='ExpiredAdDiv'>
          <div>
            <h4>Estimated daily reach</h4>
            <div className='adViews'>
              <div className='adviwqTi1'>
                <div>
                  <AiFillEye />{" "}
                </div>{" "}
                <p>{runningAd ? runningAd.views : 0} views so far</p>
              </div>
              <div className='progressBarview'>
                <div style={{ transform: `translateX(${runningAd ? runningAd.views * 3 : 0}px)` }}>
                  <div></div>
                </div>
              </div>
              <div>
                <p>0</p>
                <p>of 300</p>
              </div>
            </div>
            <div className='adViews'>
              <div className='adviwqTi1'>
                <div>
                  <GoPerson />{" "}
                </div>{" "}
                <p>Ad reached {runningAd ? runningAd.dailyReach : 0} people</p>
              </div>
              <div className='progressBarview'>
                <div style={{ transform: `translateX(${runningAd ? runningAd.dailyReach * 3 : 0}px)` }}>
                  <div></div>
                </div>
              </div>
              <div>
                <p>0</p>
                <p>of 300</p>
              </div>
            </div>
          </div>
          <div className='midRuleAd'></div>
          <div>
            <h4>Expired ad</h4>
            <div className='ExpiredAdWrapper'>
              {" "}
              {/* maxmuim three ad will be shown */}
              {expiredAd.length > 0 &&
                expiredAd.map((ad, index) => (
                  <div onClick={() => reactivatAd(ad._id)} key={index}>
                    <img className='expiredAdImg' src={`${ad.adImage.split("/upload/")[0]}/upload/f_auto,q_auto,w_160/${ad.adImage.split("/upload/")[1]}`} />

                    <button className='reactivateButton'>reactivate</button>
                  </div>
                ))}
              {/*   /}

               {/*    <div>
                        <img className="expiredAdImg" src='https://res.cloudinary.com/ebuka1122/image/upload/v1668594398/samples/Ihub-Consumer-App/Rectangle_1644_qqzkco.png'/>
                        <button className="reactivateButton">reactivate</button>
                  </div>
                  <div>
                        <img className="expiredAdImg" src='https://res.cloudinary.com/ebuka1122/image/upload/v1668594398/samples/Ihub-Consumer-App/Rectangle_1644_qqzkco.png'/>
                        <button className="reactivateButton">reactivate</button>
                  </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdComponent;
